import { gql, useMutation } from '@apollo/client';
import { useUserWithCompany } from '@app/hooks/useUserWithCompany';

const DELETE_SIGNATURE_REQUEST = gql`
  mutation DeleteSignatureRequest($id: String!) {
    deleteSignatureRequest(id: $id)
  }
`;

export interface DeleteSignatureRequestInput {
  id: string;
}

export interface DeleteSignatureRequestResult {
  deleteSignatureRequest: string;
}

export function useDeleteSignatureRequestMutation() {
  const { activeCompany } = useUserWithCompany();
  return useMutation<DeleteSignatureRequestResult, DeleteSignatureRequestInput>(DELETE_SIGNATURE_REQUEST, {
    optimisticResponse: (input) => ({
      deleteSignatureRequest: input.id,
    }),
    update(cache, { data }) {
      if (!data?.deleteSignatureRequest || !activeCompany?.id) return;

      const deletedId = data.deleteSignatureRequest;

      // Remove the signature request from the company cache
      cache.modify({
        id: cache.identify({ __typename: 'Company', id: activeCompany.id }),
        fields: {
          signatureRequests(existingRefs = [], { readField }) {
            return existingRefs.filter((ref: any) => readField('id', ref) !== deletedId);
          },
        },
      });

      // Evict the deleted signature request from cache
      cache.evict({
        id: cache.identify({ __typename: 'SignatureRequest', id: deletedId }),
      });
      cache.gc();
    },
  });
}
